import InputTextComp from "@components/UI/InputText/Index.jsx";
import { useForm } from 'react-hook-form';
import ButtonComp from "@components/UI/Button/Index.jsx";
import SweetAlert from "@components/Feedback/SweetAlert/Index.jsx";
import SelectOptionComp from "@components/UI/SelectOption/Index.jsx";
import { SaveUsuario } from "@services/Usuario/Index";
import { useFetchDataUnidades } from "@hooks/api/Unidade/useFetchDataUnidades";
import { useEffect } from "react";
import PerfilRadioGroup from "@components/Usuario/PerfilRadioGroup/Index";
import { useFetchSolicitacoesByUnidade } from "@hooks/api/Solicitacao/useFetchSolicitacoesByUnidade";
import ValidationsPermissoes from "@validations/Usuario/Validations";
import { getUserFieldProperties } from "./FieldProperties";

const Create = ({ onSave }) => {

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue
    } = useForm({
        defaultValues: {
            nome: "",
            email: "",
            perfil: "",
            unidadeGerencia: null,
            solicitacao: ""
        },
    });

    const { unitOptions, unitLoading, fetchUnits } = useFetchDataUnidades();
    const { solicitacaoOptions, solicitacaoLoading, fetchSolicitacoes } = useFetchSolicitacoesByUnidade();

    useEffect(() => {
        fetchUnits();
    }, []);

    // Sempre que a unidade mudar, busca as solicitações e reseta a seleção de solicitação
    const unidadeSelecionada = watch("unidadeGerencia");
    useEffect(() => {
        const idUnidade = unidadeSelecionada?.value;
        setValue("solicitacao", null); // Limpa o campo sempre que unidade mudar
        fetchSolicitacoes(idUnidade);  // Busca as solicitações
    }, [unidadeSelecionada, fetchSolicitacoes, setValue]);

    const onSubmit = async (data) => {
        try {
            const { warningMessage, validateEmail } = ValidationsPermissoes();

            const emailErrors = validateEmail({
                email: data.email,
            });

            if (Object.keys(emailErrors).length > 0) {
                SweetAlert.close();
                const errorMessage = Object.values(emailErrors).join("\n");
                SweetAlert.error("Erro na Validação", errorMessage);
                return;
            }

            const isConfirmed = await warningMessage(data.perfil);
            if (!isConfirmed) return;

            SweetAlert.loading();

            const payload = {
                nome: data.nome,
                email: data.email,
                perfil: data.perfil,
                idUnidadeGerencia: data.unidadeGerencia?.value,
                idSolicitacao: data.solicitacao?.value,
            };

            const result = await SaveUsuario(payload);

            SweetAlert.success('Cadastro Realizado!', 'Os dados foram salvos com sucesso.');

            onSave({ ...result });
            reset();
        } catch (error) {

            const errorMessage = error.parsed?.message || 'Não foi possível salvar o usuário.';

            SweetAlert.errorHTML('Erro ao cadastrar', errorMessage);
            console.error(error);
        }
    };

    const perfilSelecionado = watch('perfil');
    const nomeProps = getUserFieldProperties("nome", perfilSelecionado);
    const emailProps = getUserFieldProperties("email", perfilSelecionado);
    const unidadeProps = getUserFieldProperties("unidadeGerencia", perfilSelecionado, unitLoading);
    const solicitacaoProps = getUserFieldProperties("solicitacao", perfilSelecionado);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="form">
            <div className="row py-3">
                <div className="col-4 md-4">
                    <PerfilRadioGroup
                        register={register}
                        watch={watch}
                        required={true}
                    />
                </div>

                <div className="col-8 col-md-8 px-0">

                    <InputTextComp
                        label={"Nome do Usuário"}
                        name={"nome"}
                        {...register('nome')}
                        placeholder={nomeProps.placeholder}
                        disabled={nomeProps.isDisabled}
                        required={perfilSelecionado}
                        maxLength={255}
                    />

                    <InputTextComp
                        label={"E-mail do Usuário"}
                        name={"email"}
                        {...register('email')}
                        placeholder={emailProps.placeholder}
                        disabled={emailProps.isDisabled}
                        required={perfilSelecionado}
                        maxLength={255}
                    />

                    <SelectOptionComp
                        label={"Unidade"}
                        options={unitOptions}
                        isLoading={unitLoading}
                        value={watch("unidadeGerencia")}
                        onChange={(selected) => setValue("unidadeGerencia", selected)}
                        placeholder={unidadeProps.placeholder}
                        isDisabled={unidadeProps.isDisabled}
                        required={perfilSelecionado}
                    />

                    <SelectOptionComp
                        label={"Nº da Solicitação"}
                        options={solicitacaoOptions}
                        isLoading={solicitacaoLoading}
                        value={watch("solicitacao")}
                        onChange={(selected) => setValue("solicitacao", selected)}
                        placeholder={solicitacaoProps.placeholder}
                        isDisabled={solicitacaoProps.isDisabled}
                        required={perfilSelecionado}
                        hoverMessage={"Selecionar com o número da solicitação"}
                    />

                </div>

                <div className="col-12 col-md-12 justify-content-end mt-3">
                    <ButtonComp
                        title={"SALVAR"}
                        type={"submit"}
                        buttonColor={"#2b97be"}
                        classnameIcon={"fa-regular fa-floppy-disk"}
                        hoverMessage={"Botão para confirmar o cadastro"}
                    />
                </div>

            </div>
        </form>
    );
};

export default Create;